// extracted by mini-css-extract-plugin
export default {"container":"Hp-z","ratingLayout":"Ip-z","ratingLabel":"Jp-z","nonInteractiveRatingLabel":"Kp-z"};